import * as z from 'zod';

import { MultiPropertyInsuranceFields, PrimaryPropertyInsuranceFields } from '../sharedFields/InsuranceFields';
import { TaxFields } from '../sharedFields/TaxFields';
import { MultiPropertyTaxFields, PrimaryPropertyTaxFields } from '../sharedFields/TaxNestedFields';
import { ArmFields } from './ArmFields';
import { AuthorizedContactFields } from './AuthorizedContactFields';
import { AllBorrowerFields } from './BorrowerFields';
import { DeprecatedInsuranceFields, DeprecatedMultipleAddressesInsuranceFields } from './DeprecatedInsuranceFields';
import { DeprecatedMultipleAddressesTaxFields, DeprecatedTaxFields } from './DeprecatedTaxFields';
import { MortgageInsuranceFields } from './MortgageInsuranceFields';
import { RemittanceFields } from './RemittanceFields';

// By doing the merge here and only exporting a single type
// it appears to get rid of the following TS error:
//
// Recursive type: Type instantiation is excessively deep and possibly infinite.

export const CreateLoanMultipleAddressFields = z.object({
  ...DeprecatedMultipleAddressesInsuranceFields.shape, // TODO deprecate
  ...DeprecatedMultipleAddressesTaxFields.shape,
  ...MultiPropertyInsuranceFields.shape,
  ...MultiPropertyTaxFields.shape,
});
export type CreateLoanMultipleAddressFields = z.infer<typeof CreateLoanMultipleAddressFields>;

export const CreateLoanFields = z.object({
  ...MortgageInsuranceFields.shape,
  ...AllBorrowerFields.shape,
  ...AuthorizedContactFields.shape,
  ...DeprecatedInsuranceFields.shape, // TODO deprecate
  ...PrimaryPropertyInsuranceFields.shape,
  ...RemittanceFields.shape,
  ...DeprecatedTaxFields.shape,
  ...TaxFields.shape,
  ...PrimaryPropertyTaxFields.shape,
  ...ArmFields.shape,
});
export type CreateLoanFields = z.infer<typeof CreateLoanFields>;

export {
  TAX_ITEM_COUNT,
  TAX_ITEM_INDEXES,
  type TaxItemIndex,
  taxItemKeys,
  TaxEscrowTypeCoerced,
  TaxFields,
} from '../sharedFields/TaxFields';
